export const Colors = {
  blue: '#5869FF',
  primary: '#001520',
};
